import React, { useEffect, useState } from "react";

import "./index.scss";

export default function PasswordInfo({ value }) {
  const [valid, setValid] = useState({
    lowercase: false,
    uppercase: false,
    digit: false,
    special: false,
    chars: false,
  });

  const validatePassword = (password) => {
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;
    const minLength = 8;
    const maxLength = 20;
    const digitRegex = /[0-9]/;
    const specialCharRegex = /[!@#$%^&*?]/;

    setValid({
      ...valid,
      lowercase: lowercaseRegex.test(password),
      uppercase: uppercaseRegex.test(password),
      chars: password?.length >= minLength && password?.length <= maxLength,
      special: specialCharRegex.test(password),
      digit: digitRegex.test(password),
    });
  };

  useEffect(() => {
    validatePassword(value);
  }, [value]);

  const ValidationItem = ({ isValid, text }) => (
      <div className={`password-info__valid ${isValid ? "active" : ""}`}>
        <div>
          <img
              src={`/assets/icons/${isValid ? "green-check" : "gray-check"}.svg`}
              alt="check"
          />
        </div>
        <div>{text}</div>
      </div>
  );

  return (
      <div className="password-info">
        <div className="password-info__title">Your password must contain:</div>
        <ValidationItem isValid={valid.chars} text="8 to 20 characters"/>
        <ValidationItem isValid={valid.lowercase} text="Letters of lower case"/>
        <ValidationItem isValid={valid.uppercase} text="Letters of upper case"/>
        <ValidationItem isValid={valid.digit} text="Numbers"/>
        <ValidationItem isValid={valid.special} text="Special characters"/>
      </div>
  );
}
